module.exports = __webpack_public_path__ + "static/media/next-tut.22644bad.svg";